
// const vendorFields = [
//   // {
//   //   field: 'selectcommands',
//   //   label: ' ',
//   //   cell: 'selectcommands',
//   //   headerCell: 'selectCommandsHeader',
//   //   sortable: true,
//   //   hidden: false,
//   //   locked: true,
//   //   width: 30,
//   // },
//   {
//     field: 'partNumber',
//     label: 'Part Number',
//     // sortable: true,
//   },
//   {

//     field: 'mfgName',
//     label: 'Manufacturer',
//     // sortable: true,
//   },
//   {
//     field: 'source',
//     label: 'Source',
//     // sortable: true,
//   },
//   {

//     field: 'contactName',
//     label: 'Contact',
//     // sortable: true,
//   },
//   {
//     field: 'vendorType',
//     label: 'Vendor Type',
//     // sortable: true,
//   },
//   {
//     field: 'phone',
//     label: 'Phone',
//     // sortable: true,
//   },
//   {
//     field: 'email',
//     label: 'Email',
//     // sortable: true,
//   },
//   {
//     field: 'dateSent',
//     label: 'Date Sent',
//     cell: 'formatDate'
//     // sortable: true,
//   }
// ];

export const vendorFields = [
  {
    key: 'vendorName',
    label: 'Vendor',
  },
  {

    key: 'rating',
    label: 'Rating',
  },
  {
    key: 'source',
    label: 'Source',
  },
  {

    key: 'contactName',
    label: 'Contact'
  },
  {
    key: 'vendorType',
    label: 'Type',
    // sortable: true,
  },
  {
    key: 'phone',
    label: 'Phone',
    // sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    // sortable: true,
  }
];

export const partFields = [
  {
    key: 'select'
  },
  {
    key: 'partNumber',
    label: 'Part Number',
  },
  {

    key: 'mfgName',
    label: 'Manufacturer',
  },
  {
    key: 'source',
    label: 'Source',
  },
  {

    key: 'dateOffered',
    label: 'Date Offered',
  },
  {
    key: 'dateSent',
    label: 'Date Sent',
    // sortable: true,
  },
];

